<template>
  <div class="mb_20">
    <section v-if="!isFormShow">
      <div class="shop_page">
        <div class="">
          <p class="font_regular text_black_secondary font_500">
            {{$t("CATELOGUE_ORDER_PAYMENT.HEADER.LABEL")}}
            {{cart.summary.order_id}}
          </p>
          <!-- <p class="sp_title_md description">
            {{$t("CATELOGUE_ORDER_PAYMENT.HEADER.TOTAL_AMOUNT")}}
            {{cart.currency}}{{cart.summary.grantTotal}}
          </p> -->
        </div>
      </div>

      <!-- items  -->
      <section class="shop_page">
        <ItemCard
          v-for="(item,index) in cart.order_items"
          :item="item"
          :cart="cart"
          :isDivider="(cart.order_items.length-1) !== index"
          :key="index"
          @onRemove="removeItemFromCart"
          @onQuantityChange="onQuantityChange"
        />
      </section>
      <hr class="section_divider">

      <section class="shop_page">
        <h2 class="font_regular font_600 text_16">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.LABEL")}}</h2>
        <div class="payment_container mt-12">
          <div class="pay_item">
            <div class="font_regular font_500 text_14">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.TOTAL")}}</div>
            <div class="font_regular font_500 text_14">{{cart.summary.sumTotal}}</div>
          </div>
          <div class="pay_item mt_8">
            <div class="font_regular font_500 text_14">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.SST")}}</div>
            <div class="font_regular font_500 text_14">{{cart.summary.sst}}</div>
          </div>
          <div v-if="coupon.discount" class="pay_item mt_8">
            <div class="font_regular font_500 text_14 text_success">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.DISCOUNT")}}</div>
            <div class="font_regular font_500 text_14 text_success">{{coupon.discount}}</div>
          </div>
          <div class="divider mt_8 mb_8"></div>
          <div class="pay_item mt_8">
            <div class="font_regular font_600 text_16">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.TOTAL_PAY")}}</div>
            <div class="font_regular font_600 text_14 total_pay">{{cart.summary.grantTotal}}</div>
          </div>
        </div>
      </section>
      <hr class="section_divider">
<!--
      <section class="shop_page">
        <label class="input_field">
          {{$t("CATELOGUE_ORDER_PAYMENT.PROMO_CODE.LABEL")}}
          <input
            v-model="promo_code"
            class="font_regular mt_4 font_500 text_14 mb_0 promo_code"
            style="border:none;"
            type="text"
            :placeholder="$t('CATELOGUE_ORDER_PAYMENT.PROMO_CODE.PLACEHOLDER')"
            @input="clearCouponCheck"
           >
           <p v-if="coupon_err_message" class="error">{{coupon_err_message}}</p>
        </label>
      </section>
      <hr class="section_divider">
      -->

      <section class="shop_page">
        <label class="input_field">
          {{$t("CATELOGUE_ORDER_PAYMENT.REMARK.LABEL")}}
          <textarea
            v-model="cart.remark"
            class="font_regular mt_8 font_500 text_14 remark"
            type="text"
            :placeholder="$t('CATELOGUE_ORDER_PAYMENT.REMARK.PLACEHOLDER')"
            rows="5"
           />
        </label>
      </section>



      <div class="shop_page mt_24 mb_24">
        <shop-button
          className="mx-auto"
          :disabled="!isOrderBtnEnabled || isOrderDisabled || isExistOrderStatus()"
          @click="confirmOrderHandler"
        >
        Continue
        </shop-button>
        <p v-if="isOrderDisabled" style="text-align:center;">{{$t("CATELOGUE_ITEM.VARIANT.BTNS.BUSINESS_HOUR_MSG")}}</p>
      </div>
    </section>

    <section v-if="isFormShow">
      <div class="shop_page">
        <!-- <div class="input_field" style="position:relative;">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.NAME.LABEL")}}
          <input
            v-model="user.name"
            class="font_regular font_500 text_14 mt_8"
            type="text"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.NAME.PLACEHOLDER')"
          >
          <span v-if="$v.user.name.$error" class="err_msg error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.NAME.ERR_MSG")}}
          </span>
        </div> -->

        <InputField
          v-model="user.name"
          :error="$v.user.name.$error"
          :errorMessage="$t('CATELOGUE_ITEM.VARIANT.FORM.NAME.ERR_MSG')"
          :label="$t('CATELOGUE_ITEM.VARIANT.FORM.NAME.LABEL')"
          :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.NAME.PLACEHOLDER')"
        />

        <div class="input_field">
              {{$t("CATELOGUE_ITEM.VARIANT.FORM.PHONE.LABEL")}}
            <div class="phone_number_container mt_8" :class="{error:$v.user.phone_number.$error}">
              <select
                class="font_regular font_500 text_14"
                @input="onCountryCodeChange"
                v-model="user.selected_country_code"
                :disabled="false"
              >
                <option
                  v-for="code in phone_code_list"
                  :key="code.name"
                  :value="code.dial_code"
                >
                  {{code.emoji}} {{ code.dial_code }}
                </option>
              </select>
              <div class="phone_number">
                <input
                  v-model="user.input_phone_number"
                  class="font_regular font_500 text_14 phone_input"
                  type="number"
                  :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.PHONE.PLACEHOLDER')"
                  @change="onPhoneNumberChange"
                  @blur="$v.user.phone_number.$touch"
                >
                <span v-if="$v.user.phone_number.$error" class="err_msg error">{{$t("CATELOGUE_ITEM.VARIANT.FORM.PHONE.ERR_MSG")}}</span>
              </div>
            </div>
          </div>
      </div>

      <hr class="section_divider">

      <div v-if="isShipmentAddressFormOpen(merchant)" class="shipment_address shop_page">
        <!-- is deliveryOptionOpen? -->
        <div v-if="merchant.pickup_enabled" class="mb_16">
          <label class="columns small-12 medium-6 label_right">
            {{$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COLLECT_OPTION.LABEL')}}
            <RadioList
              :classWrapper="'delivery_order_shop'"
              :options="formattedDeliveryOption"
              v-model="selectedDeliveryIndex"
            />
          </label>
        </div>
        <!-- for self pickup, no need to ask for address form  -->

        <div v-if="selectedDeliveryOption !== 'self_collect'">
          <InputField
            v-model="user.shipment_address.line1"
            :error="$v.user.shipment_address.line1.$error"
            :errorMessage="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE1.ERR_MSG')"
            :label="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE1.LABEL')"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE1.PLACEHOLDER')"
          />

          <!-- city input fiels -->
          <InputField
            v-model="user.shipment_address.city"
            :error="$v.user.shipment_address.city.$error"
            :errorMessage="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.ERR_MSG')"
            :label="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.LABEL')"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.PLACEHOLDER')"
          />
          <!-- state input fiels -->
          <InputField
            v-model="user.shipment_address.state"
            :error="$v.user.shipment_address.state.$error"
            :errorMessage="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.ERR_MSG')"
            :label="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.LABEL')"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.PLACEHOLDER')"
          />

          <!-- country input fiels -->
          <div class="font_regular text_12 mb_16">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COUNTRY.LABEL")}}
            <select
                class="font_regular font_500 text_14 mt_8"
                v-model="user.shipment_address.country"
                :disabled="false"
              >
              <option
                v-for="country in merchant.permissible_countries"
                :key="country"
                :value="country"
              >
                {{country}}
              </option>
            </select>
          </div>


          <!--
          <div class="font_regular text_12 mb_16">
            {{$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.LABEL')}}
            <multiselect
              v-model="selected_city"
              :options="all_cities"
              class="small-12 font_normal order_multi_select"
              track-by="id"
              label="name"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
              :key="'city'"
              @select="onSelectCity($event)"
            />
          </div>
          -->
          <!--
          <div class="font_regular text_12 mb_16">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.LABEL")}}
            <multiselect
              v-model="selected_state"
              :options="all_states"
              class="small-12 font_normal order_multi_select"
              track-by="id"
              label="name"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
              :key="'city'"
              @select="onSelectState($event)"
            />
          </div>
          -->

          <InputField
            v-model="user.shipment_address.postal_code"
            :error="$v.user.shipment_address.postal_code.$error"
            :errorMessage="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.POSTAL_CODE.ERR_MSG')"
            :label="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.POSTAL_CODE.LABEL')"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.POSTAL_CODE.PLACEHOLDER')"
          />
        </div>



        <!--
          <div>
          <p class="shop_label">{{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE1.LABEL")}}</p>
              <input
                  v-model="user.shipment_address.line1"
                  class="field"
                  type="text"
                  :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE1.PLACEHOLDER')"
              >
            <span v-if="$v.user.shipment_address.line1.$error" class="error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE1.ERR_MSG")}}
          </span>
        </div>
        -->
        <!--
        <div>
          <p class="shop_label">{{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE2.LABEL")}}</p>
          <input
            v-model="user.shipment_address.line2"
            class="field"
            type="text"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE2.PLACEHOLDER')"
          >
          <span v-if="$v.user.shipment_address.line2.$error" class="error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.LINE2.ERR_MSG")}}
          </span>
        </div>
         -->
        <!--
        <div>
          <p class="shop_label">{{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.LABEL")}}</p>
          <input
            v-model="user.shipment_address.city"
            class="field"
            type="text"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.PLACEHOLDER')"
          >
          <span v-if="$v.user.shipment_address.city.$error" class="error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.CITY.ERR_MSG")}}
          </span>
        </div> -->
        <!--
        <div>
          <p class="shop_label">{{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.LABEL")}}</p>
          <input
            v-model="user.shipment_address.state"
            class="field"
            type="text"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.PLACEHOLDER')"
          >
          <span v-if="$v.user.shipment_address.state.$error" class="error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.STATE.ERR_MSG")}}
          </span>
        </div> -->
        <!--
        <div>
          <p class="shop_label">{{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.POSTAL_CODE.LABEL")}}</p>
          <input
            v-model="user.shipment_address.postal_code"
            class="field"
            type="text"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.POSTAL_CODE.PLACEHOLDER')"
          >
          <span v-if="$v.user.shipment_address.postal_code.$error" class="error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.POSTAL_CODE.ERR_MSG")}}
          </span>
        </div>
         -->
        <!--
        <div>
          <p class="shop_label">{{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COUNTRY.LABEL")}}</p>
          <input
            v-model="user.shipment_address.country"
            class="field"
            type="text"
            :placeholder="$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COUNTRY.PLACEHOLDER')"
          >
          <span v-if="$v.user.shipment_address.country.$error" class="error">
            {{$t("CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COUNTRY.ERR_MSG")}}
          </span>
        </div> -->

        <hr v-if="isDelvaFetched" class="section_divider">
        <div v-if="isDelvaFetched">
          <label class="deliveryOptionLabel">
            {{$t('CATELOGUE_ITEM.VARIANT.DELOVERY_MODE.LABEL')}}
            <span v-if="deliveyMode.length" class="text_black_secondary">
              {{$t('CATELOGUE_ITEM.VARIANT.DELOVERY_MODE.DISTANCE')}}
              {{deliveyMode[0].distant}} Km
            </span>
          </label>
          <DeliveryMode
              v-for="(item,index) in deliveyMode"
              :item="item"
              :selectedMode="selectedMode"
              :handleChange="handleChangeMode"
              :isLastItem="index === deliveyMode.length - 1"
              :merchant="merchant"
              :key="item.id"
          />
        </div>


      </div>
      <!-- order summary modal,  -->
        <OrderSummaryModal
          :isOpen="isSummaryOpen"
          :onClose="onSummaryClose"
          :cart="cart"
          :user="user"
          :selectedModeItem="selectedModeItem"
          :merchant="merchant"
          :onConfirm="createOrder"
          :isLoading="isOrderCreateLoading"
          :promo="promo"
          :coupon_err_message="coupon_err_message"
        />
      <!-- delivery mode modal -->

      <div v-if="isOutOfDelivery" class="error_note error">
        <!-- max_delivery_range -->
        {{$t('CATELOGUE_ITEM.VARIANT.FORM.OUT_OF_RANGE_ERR')}}
      </div>
      <div v-if="isDelvaFetched && !deliveyMode.length" class="error_note error">
        {{$t('CATELOGUE_ITEM.VARIANT.FORM.WEIGHT_SIZE_EXCEED_ERR')}}
      </div>


      <div class="section_gap_y">
        <shop-button
           v-if="needAvailableDelivFetch"
          className="mx-auto"
          @click="continueConfirmOrderHandler"
          :isLoading="isLoadingDeliveryMode"
        >
        {{$t("CATELOGUE_ITEM.VARIANT.FORM.CONTINUE_BTN")}}
        </shop-button>

        <shop-button
          v-else
          className="mx-auto"
          @click="continueConfirmOrderHandler"
          :isLoading="isOrderCreateLoading"
          :disabled="isDisableSubmit || isOutOfDelivery"
        >
        Submit Order
        </shop-button>
      </div>
    </section>
    <section class="shop_page">
        <order-list />
    </section>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ShopButton from '../../../components/ShopButton.vue';
import { required, minLength } from 'vuelidate/lib/validators';
import orderApi from "../../../api/orderApi";
import {SHOP_CONSTANT,StorageHelpers} from "./merchantHelper";
import alertMixin from 'shared/mixins/alertMixin';
import ActionCableShop from "../../../helpers/actionCable/ActionCableShop";
import OrderList from './OrderList.vue';
import {phone_code_list} from "../../../../dashboard/routes/auth/country_code";
import ItemCard from "./cart_components/ItemCard.vue";
import InputField from "../components/InputField.vue";
import RadioList from "../../../../dashboard/routes/dashboard/arrange/RadioList.vue"
import DeliveryMode from "./cart_components/DeliveryMode.vue"
import OrderSummaryModal from "./cart_components/OrderSummaryModal.vue"
import time from '../../../../dashboard/mixins/time';
import moment from "moment";

const isPhoneNumber = (value) => {
  const phoneNumberRegex = /^\+\d+$/; // Allows + sign and optional space
  return phoneNumberRegex.test(value);
};

export default {
  components: {
    ShopButton,
    OrderList,
    ItemCard ,
    InputField,
    RadioList,
    DeliveryMode,
    OrderSummaryModal,
  },
  mixins:[alertMixin],
  // inject:['merchant'],
  data() {
    // const merchant = StorageHelpers.getMerchantById(this.$route.params.accountId);
    const user = StorageHelpers.getUserContactInfo() || {};
    if (!user.shipment_address) {
      user.shipment_address={
          line1:"",
          line2:"",
          city:"",
          state:"",
          postal_code:"",
          country:"Malaysia",
      }
    }
    return {
      actionCableInstance:null,
      // merchant,
      user: user,

      cart: {
        contact: {
            // name:"",
            // phone_number:""
        },
        order_items:[],
        summary:{
          order_id: null,
          order_status:null,
          grantTotal: 0,
        },
      },

      isFormShow:false,
      isOrderCreateLoading:false,
      // isOrderBtnEnabled: false,
      phone_code_list,
      promo:{
        promo_code:""
      },
      // promo_code: "",
      coupon_err_message: null,
      delivery_options:[
        {id:'delivery',disable:false,label: this.$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COLLECT_OPTION.OPTION_1')},
        {id:'self_collect',disable:true,label: this.$t('CATELOGUE_ITEM.VARIANT.FORM.SHIPMENT_ADDRESS.COLLECT_OPTION.OPTION_2')},
      ],
      // self_collect
      selectedDeliveryIndex: 0,
      isLoadingDeliveryMode: false,
      isDelvaFetched: false,
      deliveyMode: [
        // {
        //   id: 'express',
        //   title: 'Try Express - Instant',
        //   time:'-- min',
        //   amount:'--',
        // },
        // {
        //   id: 'delivery',
        //   title: this.$t('CATELOGUE_ITEM.VARIANT.DELOVERY_MODE.REGULAR'),
        //   time:'-- min',
        //   amount:'--',
        // },
      ],
      selectedMode: null,
      selectedModeItem: null,
      // selected_state: null, // from the user object find by id
      // all_states:[
      //   {id:'state_1',name:"State 1"},
      //   {id:'state_2',name:"State 2"},
      // ],
      // selected_city: null, // from the user object find by id
      // all_cities:[
      //   {id:'city_1',name:"CIty 1"},
      //   {id:'city_2',name:"City 2"},
      // ],
      countryOptions: [],
      // selected_country:null,
      isSummaryOpen: false,
    };
  },
  computed:{
    ...mapGetters({
      uiFlags: "coupons/getUiFlags",
      coupon:"coupons/getCoupon",
    }),
    merchant(){
      const newMerchant = this.$store.getters["merchants/getCurrentMerchant"](this.$route.params.accountId);
      return newMerchant;
    },
    currentCart(){
      const currentCart = this.$store.getters["carts/getCurrentCart"](this.$route.params.accountId);
      return currentCart;
    },
    isOrderBtnEnabled(){
      return this.cart.summary?.grantTotal > 0;
    },
    isOrderDisabled() {
      return this.isOutsideBusinessHours();
    },
    formattedDeliveryOption(){
      return this.delivery_options.map(el=>{
        if (el.id === 'self_collect') {
          return {...el,disable: !this.merchant.pickup_enabled}
        }
        return el;
      })
    },
    selectedDeliveryOption(){
      if (this.selectedDeliveryIndex === null) {
        return null;
      }
      // refetch the deliveyMode when switch
      this.isDelvaFetched = false;
      this.selectedModeItem = null;
      this.selectedMode = null;
      // clear the
      return this.delivery_options[this.selectedDeliveryIndex].id;
    },
    needAvailableDelivFetch(){
      return this.merchant.delivery && this.selectedDeliveryOption ==='delivery' && !this.isDelvaFetched;
    },
    isDisableSubmit(){
      let disable = false;
      if (this.isDelvaFetched) {
        return !this.selectedModeItem;
      }
      return false;
    },
    isOutOfDelivery(){
      if (this.deliveyMode.length) {
        const deliveryDistant = this.deliveyMode[0].distant;
        const max_delivery_range = parseInt(this.merchant.max_delivery_range || '0');
        if (max_delivery_range < deliveryDistant) {
          true;
        }
      }
      return false;
    },
  },
  mounted(){
    // this.cart = this.calculateCartTotals(StorageHelpers.getCartById(this.$route.params.accountId));
    this.cart = this.calculateCartTotals(this.currentCart);
    // this.isOrderBtnEnabled = this.cart?.summary?.grantTotal > 0;
  },
  watch:{
    // update cart when account change
    '$route.params.accountId':function(newValue,oldValue){
      // this.cart = this.calculateCartTotals(StorageHelpers.getCartById(this.$route.params.accountId));
      this.cart = this.calculateCartTotals(this.currentCart);
    },
    // end watch
  },
  validations: {
    user: {
      name: {
        required,
      },
      phone_number: {
        required,
        isPhoneNumber,
      },
      shipment_address: {
        line1: {
          required
        },
        // line2: {required},
        city: {
          required
        },
        state: {
          required
        },
        postal_code: {
          required
        },
        country: {
          required
        }
      },

    },
    selectedDeliveryOption:{
      required
    }
    // end validation
  },
  methods:{
    handleChangeMode(item){
      this.selectedMode = item.id;
      this.selectedModeItem = item;
    },
    onSummaryOpen(){
      this.isSummaryOpen = true;
    },
    onSummaryClose(){
      this.isSummaryOpen = false;
    },
    async createOrder(){
      /*
      this.$v.$touch();
      if (this.$v.$error) {
        return
      }
      */


     try {
        this.$v.user.name.$touch();
        this.$v.user.phone_number.$touch();
        if (this.merchant.delivery) {
        //  atleast one option need to select
          this.$v.selectedDeliveryOption.$touch()
          if(this.merchant.delivery && this.$v.selectedDeliveryOption.$invalid){
            this.showAlert("Please select how would you collect your order")
            return
          }
          if (this.selectedDeliveryOption ==='delivery') {
            // check shipment, else not
            this.$v.user.shipment_address.$touch();
            if (this.$v.user.shipment_address.$invalid) {
              console.log("del errr");
              return
            }
          }
        }
        if (this.$v.user.name.$invalid || this.$v.user.phone_number.$invalid) {
          return
        }

        // call delivery mode options API
        if (this.needAvailableDelivFetch ) {
          // get updated merchant
          this.$store.dispatch("merchants/get",{accountId:this.$route.params.accountId});
          await this.getDeliveryTimePrice();
          return
        }

        if (this.merchant.delivery && this.selectedDeliveryOption ==='delivery' && !this.selectedModeItem && this.deliveyMode.length) {
          this.showAlert(this.$t('CATELOGUE_ITEM.VARIANT.FORM.DELIVERY_SELECT_ERR_MSG'))
          return
        }

        if (!this.isSummaryOpen) {
          // if not from summary preview, then open the preview, on confirm create the order
          this.isSummaryOpen = true;
          return;
        }

        this.isOrderCreateLoading = true;

        // store updated user name and phone, (with country code and input phone number)
        StorageHelpers.updateUserContactInfo(this.user);

        // call API to create order
        const payload = {
          currency : this.cart.currency,
          remark : this.cart.remark,
          order_items: this.cart.order_items.map((item)=>{
            return {
              item_price: item.item_price,
              quantity:item.orderQuantity,
              catalog_item_id: item.varient_id,
            }
          }),
          contact: {
            name: this.user.name,
            phone_number: this.user.phone_number,
          },
          // shipment_address:this.user.shipment_address,
        }
        if (this.merchant.delivery) {
          payload.shipment_address = this.user.shipment_address;
        }
        if (this.promo.promo_code && this.coupon.discount) {
          payload.promo_code = this.promo.promo_code;
        }

        // add delivery payload
        if (this.merchant.delivery) {
          payload.delivery = this.selectedDeliveryOption;
          payload.delyva_code = this.selectedModeItem?.companyCode;
          payload.shipping_total = this.selectedModeItem?.amount;
        }

        const {data} = await orderApi.createOrder(payload);

        if (data.id) {
          // store the order id
          this.cart.summary.order_id = data.id;
          this.cart.summary.contact_id = data.contact.id;
          this.cart.summary.pubsub_token = data.contact.pubsub_token;
          this.cart.summary.createdAt = Date.now();
          // if merchant.georestrict, then order_status=fresh
          // initially set status fresh, later based on condition, set
          // this.cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.PENDING;
          this.cart.summary.order_status = SHOP_CONSTANT.ORDER_STATUS.FRESH;
          // if not georestrict on, then Call confirm API, else check on PaymentQueue.vue component
          // if (!this.merchant.georestrict) {
          //   await orderApi.confirmOrder(data.id)
          // }

          if (!this.merchant.georestrict || payload.delivery ==='delivery') {
            await orderApi.confirmOrder(data.id);
          }

          // StorageHelpers.updateCartById(this.$route.params.accountId,this.cart);

          await this.$store.dispatch("carts/updateCartById",{
            accountId: this.$route.params.accountId,
            cart: this.cart,
          })

          this.actionCableInstance = ActionCableShop.init(data.contact.id, data.contact.pubsub_token);
          this.isFormShow = false;
          this.onSummaryClose();

          // before redirect: check if payment_before_order=true, & georestrict=false then call API to get payment_link and redirect to payment link
          if (this.merchant.payment_before_order) {
            const {data:payRes} = await orderApi.getPaymentLink(this.cart.summary.order_id,{
              order_date: new Date().toISOString(),
            })
            if (payRes.payment_link) {
              const link = document.createElement('a');
              link.href = payRes.payment_link;
              // link.target = "_blank";
              link.rel = 'noopener noreferrer';
              document.body.appendChild(link)
              link.click();
              document.body.removeChild(link);
            }else{
              // delete the order from localstore
              // const {isDeleted} = StorageHelpers.deleteCartByAccountIdAndOrderId(this.$route.params.accountId,this.cart.summary.order_id);
              await this.$store.dispatch("carts/deleteCartByAccountIdAndOrderId",{
                accountId: this.$route.params.accountId,
                order_id: this.cart.summary.order_id,
              })
              // error message that can't take payment right now
              const payErrMsg = 'We are facing technical difficulties with our payment gateway at the moment, please try again later';
              this.showAlert(payErrMsg);
              this.$router.push(`/app/accounts/${this.$route.params.accountId}`).catch(err => {});
            }
            this.isOrderCreateLoading = false;
            return
          }


          this.$router.push(`/app/accounts/${this.$route.params.accountId}/payment`).catch(err => {});
          location.reload();
        }
        this.isOrderCreateLoading = false;
        this.showAlert(this.$t("PRODUCT.ORDER_MSG.CREATE_SUCCESS_MSG"));
      } catch (error) {
        this.showAlert(this.$t("PRODUCT.ORDER_MSG.CREATE_ERR_MSG"));
        this.isOrderCreateLoading = false;
        console.log(error.response,{isOrderCreateLoading:this.isOrderCreateLoading});
        if (error.response.data?.error?.top_up?.length) {
          this.showAlert(this.$t("PRODUCT.ORDER_MSG.CREATE_ERR_MSG_TOPUP"));
        }
        else if (error.response.data?.payment_errors) {
          const payErrMsg = 'We are facing technical difficulties with our payment gateway at the moment, please try again later';
          this.showAlert(payErrMsg);
          this.$router.push(`/app/accounts/${this.$route.params.accountId}`).catch(err => {});
        }
      }

    },
    // async onCheckCoupon(){
    //   // check promo code
    //   if (this.promo_code && !this.coupon?.code) {
    //     try {
    //       const result= await this.$store.dispatch("coupons/getCoupon",{
    //         code: 'px',
    //         phone_number: "601229229292",
    //         items: this.cart.order_items.map((item)=>{
    //         return {
    //           item_price: item.item_price,
    //           quantity:item.orderQuantity,
    //           catalog_item_id: item.varient_id,
    //         }
    //       })
    //         // items:[
    //         //   {
    //         //     item_price: 10,
    //         //     quantity: 1,
    //         //     catalog_item_id: 333
    //         //   }
    //         // ],
    //       });
    //       console.log(result,"Resul");

    //     } catch (error) {
    //       console.log(error,error.message,error.response);
    //       if (error.response?.data?.error) {
    //         this.coupon_err_message = error.response?.data?.error;
    //         this.promo_code = '';
    //       }else{
    //         this.coupon_err_message = 'No coupon found';
    //         this.promo_code = '';
    //       }
    //     }
    //     return
    //   }
    // },
    async confirmOrderHandler(){
      this.isFormShow = true;
    },
    clearCouponCheck(){
      this.coupon_err_message = '';
    },
    async continueConfirmOrderHandler(){
      // this.$v.$touch();
      // if (this.$v.$error) {
      //   return
      // }
      this.createOrder();
    },

    calculateCartTotals(cart) {
      // navigate to payment if oder is pending or completed
      const {COMPLETED,PENDING} = SHOP_CONSTANT.ORDER_STATUS
      if ((cart?.summary?.order_status === PENDING)||(cart?.summary?.order_status === COMPLETED)) {
        this.$router.push(`/app/accounts/${this.$route.params.accountId}/payment`);
        return
      }

      const updatedOrderItems = cart.order_items.map(item => {
        const total = parseFloat(item.item_price) * item.orderQuantity;
        return {
          ...item,
          total: parseFloat(total.toFixed(2))
        };
      });

      const sumTotal = updatedOrderItems.reduce((acc, item) => acc + parseFloat(item.total), 0);

      const sst = this.merchant.sst === 'true' ? parseFloat(sumTotal * 0.08) : 0;  // 8% of total
      const grantTotal = sumTotal + sst;

      return {
        ...cart,
        order_items: updatedOrderItems,
        remark: this.merchant.remarks,
        summary: {
          ...cart.summary,
          sumTotal: parseFloat(sumTotal.toFixed(2)),
          sst: parseFloat(sst.toFixed(2)),
          grantTotal: parseFloat(grantTotal.toFixed(2)),
        }
      };
    },

    isOutsideBusinessHours() {
      const currentDay = new Date().getDay().toString();
      const currentTime = new Date().toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
      }); // get current time in "HH:mm" format

      console.log({currentDay,currentTime});

      const businessHour = this.merchant.business_hours?.find(
        (hour) => hour.day?.toString() === currentDay
      );

      if (businessHour) {
        const { open, close } = businessHour;
        const [openHour, openMinute] = open.split(":").map(Number);
        const [closeHour, closeMinute] = close.split(":").map(Number);
        const [currentHour, currentMinute] = currentTime.split(":").map(Number);

        const isOpen = currentHour > openHour || (currentHour === openHour && currentMinute >= openMinute);
        const isClosed = currentHour < closeHour || (currentHour === closeHour && currentMinute < closeMinute);
        return !isOpen || !isClosed;
      } else {
        return true; // disable button if no business hours for the current day
      }
    },

    isExistOrderStatus(){
      // disable confirm order btn if order status is not cancelled
      if (this.cart.summary?.order_status) {
        if (this.cart.summary?.order_status !== SHOP_CONSTANT.ORDER_STATUS.CANCELED) {
          return true;
        }
      }
    },
    isShipmentAddressFormOpen(merchant){
      return merchant?.delivery;
    },

    onCountryCodeChange(event){
      this.user.selected_country_code = event.target.value;
      this.user.phone_number = `${event.target.value}${this.user.input_phone_number}`;
    },
    onPhoneNumberChange(e){
      this.user.input_phone_number = e?.target?.value;
      this.user.phone_number = `${this.user.selected_country_code}${e?.target?.value}`;
    },
    async removeItemFromCart(item){
      if(item.varient_id){
        this.clearCouponCheck();
        // dispatch to remove item from cart
        const tepmCart = {...this.currentCart};
        tepmCart.order_items =  tepmCart.order_items.filter(orderEl=>orderEl.varient_id !== item.varient_id);
        const calcCard = this.calculateCartTotals(tepmCart);
        await this.$store.dispatch("carts/updateCartById",{
          accountId: this.$route.params.accountId,
          cart: calcCard,
        });
        this.cart = calcCard;
        // not passing full card list
        bus.$emit(SHOP_CONSTANT.EVENTS.CART_UPDATED,{});
      }
    },
    // on quantity change
    async onQuantityChange(item,type){
      if (item.varient_id) {
        this.clearCouponCheck();
        const tempCart = {...this.currentCart};
        tempCart.order_items = tempCart.order_items.map(orderEl => {
          if (orderEl.varient_id === item.varient_id) {
            if (type === 'increase') {
              return { ...orderEl, orderQuantity: orderEl.orderQuantity + 1 };
            }else if (type === 'decrease') {
              return { ...orderEl, orderQuantity: orderEl.orderQuantity - 1 };
            }
          }
          return orderEl;
        })
        .filter(orderEl => orderEl.orderQuantity > 0);

        const calcCard = this.calculateCartTotals(tempCart);

        await this.$store.dispatch("carts/updateCartById",{
          accountId: this.$route.params.accountId,
          cart: calcCard,
        });
        this.cart = calcCard;
        // not passing full card list
        bus.$emit(SHOP_CONSTANT.EVENTS.CART_UPDATED,{});

        if (tempCart.order_items.length === 0) {
          console.log("Cart is now empty.");
          this.$router.push(`/app/accounts/${this.$route.params.accountId}`)
          return
        }

      }
    },

    // on quantity decrease
    // onSelectCity(selectedItem){
    //   console.log({selectedItem});
    //   this.user.shipment_address.city = selectedItem.id;
    // },
    // onSelectState(selectedItem){
    //   console.log({selectedItem});
    //   this.user.shipment_address.state = selectedItem.id;
    // },
    onSelectCountry(selectedItem){
      // this.user.shipment_address.state = selectedItem.id;
    },
    async getDeliveryTimePrice(){
      try {
          this.isLoadingDeliveryMode = true;
         const payload = {
          currency : this.cart.currency,
          remark : this.cart.remark,
          order_items: this.cart.order_items.map((item)=>{
            return {
              item_price: item.item_price,
              quantity:item.orderQuantity,
              catalog_item_id: item.varient_id,
            }
          }),
          contact: {
            name: this.user.name,
            phone_number: this.user.phone_number,
          },
          shipment_address:this.user.shipment_address,
          account_id: this.user.accountId,
        }

        const {data} = await orderApi.fetch_available_delivery(payload);


        // do a filter on data to show only lowest budget value if !merchant.paid_by_customer

        let dataList = data.map(el=>{
          /*
          const totalSeconds = el.duration;
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          let formattedTime = '';
          if (hours > 0) formattedTime += `${hours} hr `;
          if (minutes > 0) formattedTime += `${minutes} min `;
          if (seconds > 0 && hours === 0) formattedTime += `${seconds} sec`;
          */

        const estimated_packed_time = parseInt(this.merchant?.estimated_packed_time || '0')
        const duration = parseInt(el.duration / 60);  // if durarion is negative then show "Estimated Delivery not available"

        const totalMin = duration + estimated_packed_time;
        const durationM = moment.duration(totalMin, "minutes");
        const days = Math.floor(durationM.asDays());
        const hours = Math.floor(durationM.hours());
        const minutes = Math.floor(durationM.minutes());
        let timeString = [];
        if (days > 0) timeString.push(`${days} days`);
        if (hours > 0) timeString.push(`${hours} hours`);
        if (minutes > 0) timeString.push(`${minutes} mins`);

          // with duration+merchant.estimated apck time

          return {
            id: el.id,
            title: el.name,
            // time: duration + estimated_packed_time + ' min',
            time: el.duration > 0 ? timeString.join(', ') : this.$t('CATELOGUE_ITEM.VARIANT.DELOVERY_MODE.DELIVERY_NOT_AVAILABLE'),
            // amount: el.price.amount,
            amount: el.total_price,
            currency: el.price.currency,
            companyCode: el.companyCode,
            distant: el.distant,
          }
        })

        if (!this.merchant.paid_by_customer) {
          dataList = dataList.sort((a,b)=>a.amount - b.amount).slice(0,1);
        }

        this.deliveyMode = dataList;

        this.isLoadingDeliveryMode = false;
        this.isDelvaFetched = true;
      } catch (error) {
        console.log(error);
        this.showAlert(this.$t('CATELOGUE_ITEM.VARIANT.FORM.DELIVERY_API_ERR_MSG'));
        this.isLoadingDeliveryMode = false;
      }
    },
    // end of methods
  },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';


.mx-auto{
  margin-left: auto;
  margin-right: auto;
}




// iOS-Specific Fix
@supports (-webkit-fill-available: 0) {
  td {
    height: auto;
  }
}

.variant_grid_container{
  max-width: 100%;
  border-radius: var(--b-md);
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  overflow-x: auto;
}
.grid_system{
  display: grid;
  grid-template-columns: 1fr 80px 100px 90px;
  gap: 1px;
  // padding: 0.8rem 1rem 1rem;
  > div{
    border-right: 1px solid #c4bebe;
    padding: 1rem 0.8rem;
    @media(max-width: 480px){
      padding: 0.8rem 0.6rem;
    }
  }
  @media(max-width: 480px){
    grid-template-columns: 1fr 60px 70px 70px;
  }
}
.grid_header{
  min-height: 60px;
  font-weight: 600;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  font-size: 1.4rem;
  background-color: var(--primary-color);
  color: #fff;
  @media(max-width: 480px){
    font-size: 1.2rem;
  }

  div{
    display: flex;
    align-items: center;
  }
}
.grid_data{
  font-size: 14px;
  color: #3c4858;
}
.grid_data:nth-of-type(odd) {
  background-color: var(--bg-secondary);
}

.align_right{
  text-align: right;
}

.item_details{
  display: flex;
  justify-content: space-between;
}

.font_bold{
  font-weight: 600;
}

.field{
  margin-bottom: 0;
}
.error{
  color: red;
}
.err_msg{
  position: absolute;
  bottom: -17px;
}

.phone_number_container{
  position: relative;
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
  border: 1px solid #EEEEEE;
  border-radius: 6px;
  &:focus-within{
    border-color: #8D25F6;
  }

  select{
    margin: 0;
    border: none;
  }
  .phone_number{
    margin: 0;
    input{
      border: none;
    }
  }
}

.deliveryOptionLabel{
  display: flex;
  justify-content: space-between;
}

.error_note{
  color: red;
  text-align: center;
}

/*
.remark{
  margin:25px auto 44px auto;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 8px;
  padding: 20px 10px;
  background: #EAF0FC;

  .remark_label{
    font-weight: 600;
    color: var(--txt-secondary);
  }

  span{
    font-size: 14px;
  }
  textarea{
    font-size: 14px;
    &::placeholder{
      font-size: 14px;
    }
  }
}
*/

.payment_container{
  margin-top: 12px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #EEEEEE;
  .pay_item{
    display: flex;
    justify-content: space-between;
  }
  div{
    .total_pay{
      color: #8D25F6;
    }
  }
}
.promo_code{
  padding-left: 0;
}
.remark{
  padding: 12px;
}
.phone_input{
  margin-bottom: 0;
}

.delivery_order_shop{
  margin-top: 4px;
  display: flex;
  gap: 24px;
}

</style>

<style>

.shipment_address .delivery_order_shop input,
.shipment_address .delivery_order_shop .radio-item{
    gap: 4px;
    margin: 0;
    align-items: center;
}
.shipment_address .delivery_order_shop p{
    margin: 0;
    margin-top: 1px;
}
.shipment_address .delivery_order_shop p b{
    font-weight: 500;
    font-size: 14px;
    color: #304352;
}
.shipment_address .delivery_order_shop .radio-item .radio_wrap input{
    border-color: #858585;
}
.shipment_address .delivery_order_shop .radio-item .radio_wrap input:checked{
    border-color: var(--w-500);
}
</style>